var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustom = function SvgCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.778-6.306 14.084-14.083 14.084C6.6 33.453.295 27.143.295 19.365.295 11.586 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.059 25.043h-7.645c-.44 0-.847-.17-1.158-.481a1.625 1.625 0 0 1-.478-1.158V15.76c0-.435.171-.847.482-1.157.31-.311.722-.482 1.158-.482h3.822a.549.549 0 0 1 0 1.095h-3.822a.54.54 0 0 0-.388.16.54.54 0 0 0-.16.388v7.642a.54.54 0 0 0 .16.387.54.54 0 0 0 .388.16h7.641a.54.54 0 0 0 .387-.16.54.54 0 0 0 .16-.387v-3.823a.549.549 0 0 1 1.096 0v3.823c0 .436-.171.848-.482 1.158-.31.31-.721.482-1.157.482l-.004-.004Zm-5.458-3.275a.547.547 0 0 1-.53-.68l.544-2.184a.544.544 0 0 1 .143-.255l5.186-5.186c.645-.645 1.765-.645 2.41 0 .32.32.499.75.499 1.203 0 .454-.178.883-.5 1.204l-5.185 5.186a.546.546 0 0 1-.255.143l-2.183.548a.58.58 0 0 1-.133.017l.004.004Zm1.04-2.452-.29 1.154 1.154-.29 5.078-5.078a.607.607 0 0 0 .178-.432.607.607 0 0 0-.178-.433.628.628 0 0 0-.865 0l-5.078 5.079Z",
    fill: "#0086C9"
  })));
};

export default SvgCustom;